import React, { useState, useEffect } from 'react';
import { Columns3 } from 'lucide-react';
import { useColumnPreferences } from '../../context/ColumnPreferencesContext';
import ColumnConfiguratorModal from './ColumnConfiguratorModal';
import { getDefaultColumns } from '../../config/columnDefaults';
import './ColumnConfigurator.css';

/**
 * Drop-in "Columns" button for any entity list toolbar.
 * Shows a badge when columns are customized from defaults.
 * Opens the ColumnConfiguratorModal on click.
 */
function ColumnsButton({ entityType }) {
  const { loadColumns, getVisibleColumns } = useColumnPreferences();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    loadColumns(entityType);
  }, [entityType, loadColumns]);

  const visibleColumns = getVisibleColumns(entityType);
  const defaults = getDefaultColumns(entityType);
  const defaultVisibleCount = defaults.filter(c => c.defaultVisible || c.visible).length;
  const isCustomized = visibleColumns.length !== defaultVisibleCount;

  return (
    <>
      <button
        className="btn btn-secondary columns-btn"
        onClick={() => setShowModal(true)}
        title="Configure columns"
      >
        <Columns3 size={18} />
        Columns
        {isCustomized && (
          <span className="columns-btn-badge">{visibleColumns.length}</span>
        )}
      </button>
      <ColumnConfiguratorModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        entityType={entityType}
      />
    </>
  );
}

export default ColumnsButton;
